import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { listCitiesOptions } from '../../../features/cities/queries';
import { ImportQueueFilters } from '../../../features/import-queue/components/import-queue-filters';
import { ImportQueueTable } from '../../../features/import-queue/components/import-queue-table';
import { type ImportQueueListFilters, listImportQueueOptions } from '../../../features/import-queue/queries';
import { listSourceChannelsOptions } from '../../../features/source-channels/queries';
import { PageHeader } from '../../../shared/components/page-header';
import { Route as ImportQueueRoute } from './route';

function toFilters(search: ReturnType<typeof ImportQueueRoute.useSearch>): ImportQueueListFilters {
  const out: ImportQueueListFilters = {
    status: search.status,
    limit: search.limit,
  };
  if (search.cityId !== undefined) out.cityId = search.cityId;
  if (search.channelId !== undefined) out.channelId = search.channelId;
  if (search.from !== undefined) out.from = search.from;
  if (search.to !== undefined) out.to = search.to;
  if (search.cursor !== undefined) out.cursor = search.cursor;
  return out;
}

export const Route = createFileRoute('/_authenticated/import-queue/')({
  loaderDeps: ({ search }) => ({
    status: search.status,
    cityId: search.cityId,
    channelId: search.channelId,
    from: search.from,
    to: search.to,
    cursor: search.cursor,
    limit: search.limit,
  }),
  loader: async ({ context, deps }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(listCitiesOptions()),
      context.queryClient.ensureQueryData(listSourceChannelsOptions()),
      context.queryClient.ensureQueryData(listImportQueueOptions(toFilters(deps))),
    ]);
  },
  component: ImportQueueIndexPage,
});

function ImportQueueIndexPage() {
  const search = ImportQueueRoute.useSearch();
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const { data: channels } = useSuspenseQuery(listSourceChannelsOptions());
  const { data: list } = useSuspenseQuery(listImportQueueOptions(toFilters(search)));

  return (
    <div>
      <PageHeader
        title="Очередь импорта"
        description="События, извлечённые из Telegram-каналов и ожидающие модерации."
      />
      <ImportQueueFilters
        cities={cities}
        channels={channels}
        value={{
          status: search.status,
          cityId: search.cityId,
          channelId: search.channelId,
          from: search.from,
          to: search.to,
        }}
      />
      <ImportQueueTable
        items={list.items}
        cities={cities}
        channels={channels}
        nextCursor={list.nextCursor}
        currentCursor={search.cursor}
        currentSearch={search}
      />
    </div>
  );
}
